@import "src/helpers/ScreenSizes.scss"; //mixins for different screen sizes

@mixin userText() {
  justify-content: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  font-feature-settings: "liga" off;
}

.switchContainer {
  display: flex;
  flex-direction: row;
  gap: 0.5em 0.3em;
  justify-content: center;
  @include extraSmall(){
    flex-direction: column;
  }
  @include isMobile(){
    flex-direction: column;
  }
}

.userEmail {
  @include userText();
  color: #16182b;
}

.userChange {
  @include userText();
  color: #4d5ef2;
  cursor: pointer;
}
